const transitions = {
    transition: 'transitionend',
    OTransition: 'oTransitionEnd',
    MozTransition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd'
};

export default function getTransitionEvent() {
    let el = document.createElement('fake');
    for (let t in transitions) {
        if (el.style[t] !== undefined) {
            return transitions[t];
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/transitionEvent.js